module.exports = __webpack_public_path__ + "img/beer_id-47.bd248d36.png";